module.exports = __webpack_public_path__ + "media/images/area/area_nagasakiM400-be938bec51cedd5a6aaa86e75f3d730e.jpg";